import { CommentList } from "@/features/comments/components/CommentList"

interface DiscussionSectionProps {
  entityId: string
  canComment: boolean
  canReply?: boolean
  canModerate: boolean
}

export function DiscussionSection({
  entityId,
  canComment,
  canReply,
  canModerate,
}: DiscussionSectionProps) {
  return (
    <div id="discussion">
      <CommentList
        entityType="ritual"
        entityId={entityId}
        canComment={canComment}
        canReply={canReply}
        canModerate={canModerate}
      />
    </div>
  )
}
